import { IconButton } from "@/components/ui/icon-button";
import { type IconNames } from "../icons/icon-map";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu/";
import { Typography } from "../typography";
import { View } from "@/components/ui";
import React from "react";

export interface ActionItem {
  label: string;
  render?: (label: string) => React.ReactNode;
  onClick: () => void;
}

export const OtherActionsDropdown = ({
  icon = "dotsThreeOutline",
  actions,
  size = "sm",
}: {
  icon?: IconNames;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  actions: ActionItem[];
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton
          iconName={icon}
          color="CTA2"
          variant="secondary"
          rounded="full"
          size={size}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {actions.map((action, index) => (
          <React.Fragment key={`${action.label}-${index}`}>
            {index !== 0 && <DropdownMenuSeparator />}
            <DropdownMenuItem className="cursor-pointer">
              <View onClick={action.onClick}>
                {action.render ? (
                  action.render(action.label)
                ) : (
                  <Typography variant="body-sm">{action.label}</Typography>
                )}
              </View>
            </DropdownMenuItem>
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
